import React, { useContext } from 'react';
import {
  Box, Typography
} from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import NavBar from './components/NavBar';
import FilterBar from './components/FilterBar';
import TriggersStackedBarChart from './components/data_visualizations/TriggersStackedBarChart';
import TriggerTable from './components/data_visualizations/TriggerTable';
import theme from './theme';
import { useGlobalLoading } from './context/GlobalLoadingContext';

function TriggersPage() {
  const { loading } = useGlobalLoading();  // use the actual global loading context

  if (loading) {
    return <Typography>Loading...</Typography>;
  }

  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <Box sx={{ padding: 3 }}>
        <Typography variant="h4" gutterBottom>
          Buying Behaviors
        </Typography>
        <FilterBar />
        
        <Box my={4}>
          <Typography variant="h6">Most Common Triggers for Seeking a New Solution</Typography>
          <TriggersStackedBarChart />
        </Box>

        <Box my={4}>
          <Typography variant="h6">Trigger Data Table</Typography>
          <TriggerTable />
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default TriggersPage;
